<app-leveltwo  [pageName]="'Business Property Assessments'">
    <div heading="General Info" class="General">
      <h3>{{'Businesspropstatements.PageTitle'|translate}}</h3>
      <!--
        <h4>{{'Businesspropstatements.Pagesubtitle'|translate}}</h4>
      -->
      <p>{{'Businesspropstatements.ThelosAngeles'|translate}}</p>
      <p>{{'Businesspropstatements.Eachyear'|translate}}</p>
      <p>{{'Businesspropstatements.Businesseswithv2'|translate}}</p>
      <p>{{'Businesspropstatements.Generallybusiness'|translate}}</p>
      <p>{{'Businesspropstatements.Instead'|translate}}</p>
       <p [innerHTML]="'Businesspropstatements.Formorev2'|translate"></p>

        <!--
        <a href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1622783798/Form/BOE-571-L.pdf" type="button" class="btn btn-primary" target="_blank">{{'Businesspropstatements.downloadform'|translate}}</a>
        <br><br>-->
        <a href="https://efile.assessor.lacounty.gov/efilela/main.jsp" type="button" class="btn btn-primary" target="_blank">{{'Businesspropstatements.efile'|translate}}</a>
      <br><br>


    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->

</app-leveltwo>
